import {Dispatch, FC} from 'react';
import Modal from 'react-modal';
import {Button} from '../Button';
import {generalPopupStyles} from '../../../constants/popupStyles';

const confirmLabel = 'Ok';

Modal.setAppElement(document.getElementById('root'));

interface SuccessPopupProps {
  labels: {
    body: string,
    confirmBtn?: string,
  };
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  confirmableAction?: () => void;
}

const SuccessPopup: FC<SuccessPopupProps> = ({
  labels,
  isOpen,
  setIsOpen,
  confirmableAction = () => null
}) => {
  const closeModal = () => {
    confirmableAction();
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={generalPopupStyles}
      contentLabel="Success Popup"
    >
      <div className="success-popup">
        <p className="body">{labels.body}</p>
        <div className="buttons">
          <Button
            label={labels.confirmBtn || confirmLabel}
            onClick={closeModal}
          />
        </div>
      </div>
    </Modal>);
};

export default SuccessPopup;
